import { computed, ref, unref } from 'vue'

/**
 * 列表默认截断展示 + 查看更多 的通用逻辑
 * @param {Ref<Array>|Function} source 数据源（ref / getter / 数组）
 * @param {Number} defaultVisibleCount 默认展示条数
 */
export function useExpandableList(source, defaultVisibleCount) {
  const expanded = ref(false)

  const resolveList = () => {
    const raw = typeof source === 'function' ? source() : unref(source)
    return Array.isArray(raw) ? raw : []
  }

  const displayList = computed(() => {
    const list = resolveList()
    return expanded.value ? list : list.slice(0, defaultVisibleCount)
  })

  const showMoreButton = computed(
    () => !expanded.value && resolveList().length > defaultVisibleCount
  )

  const resetExpand = () => {
    expanded.value = false
  }

  return {
    expanded,
    displayList,
    showMoreButton,
    resetExpand
  }
}
